<template>
    <!--入库申请tab-->
    <div>
        <!--头部-->
        <div class="flex0">
            <el-select style="width: 145px"  class="marr4" v-model="isAccountTime" size="mini" filterable :placeholder="$t('form_please_select')">
                <el-option
                        v-for="item in timeType"
                        :key="item.i_id"
                        :label="item.vc_name"
                        :value="item.i_id">
                </el-option>
            </el-select>
            <el-date-picker
                    class="marr4"
                    size="mini"
                    v-model="begin_time"
                    formt="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 15%"
                    :placeholder="$t('promanagement_startDate')"　>
            </el-date-picker>
            <el-date-picker
                    class="marr4"
                    size="mini"
                    v-model="end_time"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 15%"
                    :placeholder="$t('promanagement_endDate')"　>
            </el-date-picker>
            <el-input class="marr4" style="width: 15%" v-model="vcName" :placeholder="$t('promanagement_search_for_product_name_or_batch_number')"　 clearable size="mini"></el-input>
            <el-button  icon="el-icon-search" circle  @click="searchData" size="mini"></el-button>
            <el-button  type="primary"  :class="baseerp+'btn'" @click="addData" :disabled="disabled" size="mini">{{$t('button_add')}}</el-button>
        </div>
        <!--列表-->
        <div>
            <el-table
                    border
                    ref="table"
                    class="mrt10"
                    size="mini"
                    :data="tableData"
                    :height="tableHeight"
                    :header-cell-style="{background:'#eef1f6',color:'#000'}"
                    :highlight-current-row="highlightCurrentRow">
                <el-table-column
                        prop="i_id"
                        label="ID"
                        show-overflow-tooltip
                        width="90">
                </el-table-column>
                <el-table-column
                        prop="vc_pzname"
                        :label="$t('form_product_name')"
                        show-overflow-tooltip
                        min-width="180">
                </el-table-column>
                <el-table-column
                        prop="vc_no"
                        :label="$t('form_serial_number')"
                        show-overflow-tooltip
                        min-width="110">
                </el-table-column>
                <el-table-column
                        prop="f_num"
                        :label="$t('form_quantity')"
                        width="70"
                        align="right">
                </el-table-column>
                <el-table-column
                        prop="f_innum"
                        :label="$t('promanagement_already_in_stock')"
                        show-overflow-tooltip
                        width="70"
                        align="right">
                </el-table-column>
                <el-table-column
                        prop="vc_unit"
                        :label="$t('form_metering')"
                        show-overflow-tooltip
                        width="70">
                </el-table-column>
                <el-table-column
                        prop="vc_ingsname"
                        :label="$t('form_company')"
                        show-overflow-tooltip
                        min-width="180">
                </el-table-column>
                <el-table-column
                        prop="vc_inckname"
                        :label="$t('form_warehouse')"
                        show-overflow-tooltip
                        width="85">
                </el-table-column>
                <el-table-column
                        prop="dt_createtime"
                        :label="$t('form_application_date')"
                        show-overflow-tooltip
                        min-width="180">
                </el-table-column>
                <el-table-column
                        prop="dt_accounttime"
                        :label="$t('promanagement_accountingTime')"
                        show-overflow-tooltip
                        min-width="180">
                </el-table-column>
                <el-table-column
                        prop="vc_lruname"
                        :label="$t('form_input_person')"
                        width="80"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="vc_state"
                        :label="$t('promanagement_has_it_been_fully_stored_in_the_warehouse')"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        fixed="right"
                        :label="$t('form_operate')"
                        width="50">
                    <template slot-scope="scope">
                        <el-button @click="edit(scope.row)" type="text" size="small">{{$t('button_edit')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    class="fr page"
                    background
                    layout="prev, pager, next"
                    @current-change="pageCurrentChange"
                    :current-page.sync="currentPage"
                    :total="tableTotal"
                    :page-size="pageSize">
            </el-pagination>
        </div>
        <!--添加/编辑dialog-->
        <div :class="baseerp+'div'">
            <el-dialog
                     width="1000px"
                    :title="title"
                    :visible.sync="DialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="DialogVisible">
                <putin-form :putinform="putinform" @close="cancelDialog" @getWarehousingList="getWarehousingList"></putin-form>
            </el-dialog>
        </div>
        <!--产出dialog-->
        <!--        <div :class="baseerp+'div'">-->
        <!--            <el-dialog-->
        <!--                     width="1000px"-->
        <!--                    :title="title"-->
        <!--                    :visible.sync="produceDialogVisible"-->
        <!--                    :close-on-click-modal="false"-->
        <!--                    @close="cancelDialog"-->
        <!--                    v-if="produceDialogVisible">-->
        <!--                <produce-form :produce="produce" @close="cancelDialog" @getConsumeList="getConsumeList" @addLine="addLine"></produce-form>-->
        <!--            </el-dialog>-->
        <!--        </div>-->
        <!--在线退回dialog-->
        <!--        <div :class="baseerp+'div'">-->
        <!--            <el-dialog-->
        <!--                     width="1000px"-->
        <!--                    :title="title"-->
        <!--                    :visible.sync="returnDialogVisible"-->
        <!--                    :close-on-click-modal="false"-->
        <!--                    @close="cancelDialog"-->
        <!--                    v-if="returnDialogVisible">-->
        <!--                <return-list :returnlist="returnlist" @close="cancelDialog" @getConsumeList="getConsumeList" ></return-list>-->
        <!--            </el-dialog>-->
        <!--        </div>-->
        <!--分页-->
        <!--<div>

        </div>-->
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import PutinForm from "./PutinForm";
    //import FeedingForm from "./FeedingForm";
    //import ProduceForm from "./ProduceForm";
    //import ReturnList from "./ReturnList";



    export default {
        name: "WarehouseApplication",
        components: {PutinForm},
        props:{
            formvalue:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                timeType:[  {i_id:0,vc_name:this.$t('promanagement_search_by_entry_time')},
                            {i_id:1,vc_name:this.$t('promanagement_search_by_accounting_time')}],
                isAccountTime:0,
                begin_time:"",
                end_time:"",
                vcName:"",
                disabled:false,
                //添加
                putinform:{},
                DialogVisible:false,
                //外
                taskDa:{},
                taskId:"",
                pageSize:13,
                currentPage:1,
                tableTotal:0,
                i_id:"",
                title:"",
                highlightCurrentRow:true,
                tableData:[
                ],
                baseerp:"",
                mid:0,
                tableHeight:0,
            }
        },

        watch:{
            formvalue:{
                handler(){
                    // console.log(this.formvalue,"从tasklist窜过来");
                    if (this.formvalue){
                        this.mid=this.formvalue.i_mid;
                        if(this.i_id!=this.formvalue.i_id) {
                            if ((this.formvalue.i_id ?? '' !== '') && (this.formvalue.i_id != 0)) {
                                this.taskDa = this.formvalue.value;
                                this.taskId = this.formvalue.i_id;

                                //this.i_type = this.formvalue.i_type;
                                //this.apptitle = this.formvalue.title;
                                this.getWarehousingList();
                                //console.log(this.taskDa,this.taskId,"this.task");
                                /*if (this.formvalue.value.dt_createtime>=this.formvalue.value.dt_starttime&&this.formvalue.value.dt_createtime<=this.formvalue.value.dt_endtime){
                                    this.disabled=false;
                                   // console.log(this.formvalue.value.dt_createtime,this.formvalue.value.dt_starttime,this.formvalue.value.dt_endtime,"check")
                                }else{
                                    this.disabled=true;
                                };250804*/
                                //console.log(this.formvalue.value.jz,"this.jz");
                                if(this.formvalue.value.jz==true){
                                    this.disabled=true;
                                }else{
                                    this.disabled=false;
                                }
                            }
                        }
                    }
                },
                immediate:true,
                deep:true
            },
        },
        mounted() {
            this.baseerp=baseerp;
            this.$nextTick(function () {
                window.addEventListener('resize',this.heightAuto);
                this.heightAuto();
            });
        },
        methods: {

            // addLine(val){ //添加行数
            //     console.log(val,"vallll")
            //     var newValue = {
            //         i_id: val.i_id,
            //         vc_pzname: val.vc_pzname,
            //         vc_no:  val.vc_no,
            //         vc_unit:  val.vc_unit,
            //         f_innum: val.f_innum,
            //         f_innum_zb: val.f_innum_zb,
            //         f_outnum:  val.f_outnum,
            //         f_outnum_zb: val.f_outnum_zb,
            //         dt_tltime: val.dt_tltime,
            //         vc_bc: val.vc_bc,
            //         vc_scxname: val.vc_scxname,
            //         vc_note: val.vc_note,
            //         dt_createtime: val.dt_createtime,
            //         vc_lrnname: val.vc_lrnname,
            //         c_type: val.c_type,
            //         i_pid: val.i_pid
            //     };
            //     //添加新的行数
            //     this.tableData.unshift(newValue);
            // },


            heightAuto(){
                this.tableHeight = window.innerHeight - this.$refs.table.$el.clientTop - 280;
            },
            //点击添加
            addData(){
                if(this.formvalue.title==null||this.formvalue==null){
                    this.DialogVisible=false;
                    this.$message.error(this.$t('promanagement_please_select_the_desired_option_to_add_the_left_side_order'))
                }else{
                    this.title=this.$t('promanagement_add_inventory_application');
                    this.highlightCurrentRow=true;
                    this.putinform={
                        taskId:this.taskId,
                        taskDa:this.taskDa,
                        value:"",
                        i_id:0,
                        page_size:1,
                        i_mid:this.mid,
                        jz:this.formvalue.value.jz,
                    };
                    // console.log(this.putinform,"putinform");
                    this.DialogVisible=true;
                }
            },

            //点击产出
            // produceDialog(){
            //     if(this.formvalue.title==null||this.formvalue==null){
            //         this.produceDialogVisible=false;
            //         this.$message.error("请选择要的添加左侧单！")
            //     }else{
            //         this.title="添加产出";
            //         this.highlightCurrentRow=true;
            //         this.produce={
            //             taskId:this.taskId,
            //             taskDa:this.taskDa,
            //             c_type:16,
            //             i_id:0,
            //             value:"",
            //             page_size:1,
            //         };
            //         console.log(this.produce,"produce");
            //         this.produceDialogVisible=true;
            //     }
            // },



            //点击投料
            // feedDialog(){
            //     if(this.formvalue.title==null||this.formvalue==null){
            //         this.feedDialogVisible=false;
            //         this.$message.error("请选择要的添加左侧单！")
            //     }else{
            //         this.title="添加投料";
            //         this.highlightCurrentRow=true;
            //         this.feeding={
            //             taskId:this.taskId,
            //             taskDa:this.taskDa,
            //             c_type:7,
            //             i_id:0,
            //             value:"",
            //             page_size:1,
            //         };
            //         console.log(this.feeding,"feeding");
            //         this.feedDialogVisible=true;
            //     }
            // },

            //编辑
            edit(row){
                // console.log(row,"row");
                this.title=this.$t('promanagement_edit_inventory_application');
                this.putinform={
                    taskId:this.taskId,
                    taskDa:this.taskDa,
                    i_id:row.i_id,
                    value:row,
                    title:this.$t('promanagement_edit_inventory_application'),
                    page_size:this.currentPage,
                    i_mid:this.mid,
                };
                // console.log(this.putinform,"编辑入库申请");
                this.DialogVisible=true;
            },

            cancelDialog(){
                    this.DialogVisible=false;
                    this.highlightCurrentRow=true;
                // if (this.title=="添加投料"||this.title=="编辑投料"){
                //     this.feedDialogVisible=false;
                //     this.highlightCurrentRow=true;
                // }else if(this.title=="添加产出"||this.title=="编辑产出"){
                //     this.produceDialogVisible=false;
                //     this.highlightCurrentRow=true;
                // }else if (this.title=="在线退回"){
                //     this.returnDialogVisible=false;
                // }
            },
            searchData(){
                // console.log(this.vcName,this.begin_time,this.end_time,"searchData")
                if(this.formvalue.title==null||this.formvalue==null){
                    this.$message.error(this.$t('promanagement_please_select_the_desired_option_to_add_the_left_side_order'))
                    return
                }
                this.getWarehousingList();
            },
            //调用入库申请列表接口
            async getWarehousingList(){
                let param={
                    i_mid: this.mid,
                    i_id:this.formvalue.i_id,
                    page_size:this.currentPage,
                    page_count:13,
                    begin_time:this.begin_time?this.begin_time:'',
                    end_time:this.end_time?this.end_time:'',
                    vc_name:this.vcName,
                    isAccountTime:this.isAccountTime,
                };
                let res=await API.getWarehousingList(param);
                if ( res.code == 1 ){
                    this.tableData=res.data;
                    this.tableTotal=res.count;
                    // console.log(this.tableData,"this.tableData")
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            //分页
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.getWarehousingList();
            }
        },
        beforeDestroy() {
            window.removeEventListener('resize',this.heightAuto)
        },
    }
</script>

<style lang="scss" scoped>
    .mrt10{
        margin-top: 6px;
    }
    .marr4{
        margin-right: 6px;
    }
    .mrb20{
        margin-bottom: 8px;
    }

    .fr{
        float: right;
    }

    /deep/{

        .el-dialog__body{
            word-break:unset;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 150px;
        }
        .page {
            padding: 6px;
        }

    }
</style>